import React, { useEffect, useState } from 'react';
import css from './OurLearnersCard.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import oliver from '../../../../../assets/oliver.png';
import sebastian from '../../../../../assets/sebastian.png';
import antonio from '../../../../../assets/antonio.png';
import Slider from 'react-slick';
import { FormattedMessage, injectIntl, intlShape } from '../../../../../util/reactIntl';
import '../../../../../styles/slick.min.css';
import '../../../../../styles/slick-theme.min.css';
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27Z"
          fill="#1C3533"
        />
        <path
          d="M11.1372 18.2249L15.8622 13.4999L11.1372 8.7749"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 27C6.04416 27 0 20.9558 0 13.5C0 6.04416 6.04416 0 13.5 0C20.9558 0 27 6.04416 27 13.5C27 20.9558 20.9558 27 13.5 27Z"
          fill="#1C3533"
        />
        <path
          d="M15.8628 18.2249L11.1378 13.4999L15.8628 8.7749"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

const testimonials = [
  {
    id: 1,
    nameId: 'OurLearnersCard.testimonial1.name',
    textId: 'OurLearnersCard.testimonial1.text',
    img: oliver,
    locationName: 'OurLearnersCard.testimonial1.locationName',
  },
  {
    id: 2,
    nameId: 'OurLearnersCard.testimonial2.name',
    textId: 'OurLearnersCard.testimonial2.text',
    img: sebastian,
    locationName: 'OurLearnersCard.testimonial2.locationName',
  },
  {
    id: 3,
    nameId: 'OurLearnersCard.testimonial3.name',
    textId: 'OurLearnersCard.testimonial3.text',
    img: antonio,
    locationName: 'OurLearnersCard.testimonial3.locationName',
  },
];

const OurLearnersCardComponent = props => {
  const { intl } = props;
  const colors = ['#A9FBD7', '#FFEAAF', '#F3D7F6'];
  const [slideCount, setSlideCount] = useState(1.2);
  const [screenWidth, setScreenWidth] = useState();

  const getColoredText = (textId, index) => {
    const text = intl.formatMessage({ id: textId });
    const color = colors[index % 3];
    return text.replace(/<span>/g, `<span style="background-color: ${color};">`);
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      if (width >= 1440) {
        setSlideCount(3);
      } else if (width >= 1280) {
        setSlideCount(2.8);
      } else if (width >= 768) {
        setSlideCount(2.1);
      } else {
        setSlideCount(1.2);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    speed: 600,
    slidesToShow: slideCount, // always show 3
    slidesToScroll: 1,
    // arrows: testimonials.length > 1,
    arrows: screenWidth >= 600 ? true : false,
    dots: screenWidth >= 600 ? false : true,
    // autoplay: true,
    // autoplaySpeed: 5000,
    // cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <div>
      <section className={css.wrapper}>
        <h2 className={css.heading}>
          <FormattedMessage id="OurCategories.hearDirectly" />
        </h2>
        <p className={css.subheading}>
          <FormattedMessage id="OurCategories.parentsStudents" />
        </p>

        <div className={css.cards}>
          <Slider {...settings}>
            {testimonials.map((t, index) => {
              return (
                <div key={t.id} className={css.card}>
                  <div>
                    <div className={css.quoteIcon}>
                      <IconCard type="orangestar" />
                      <IconCard type="orangestar" />
                      <IconCard type="orangestar" />
                      <IconCard type="orangestar" />
                      <IconCard type="orangestar" />
                    </div>
                    <p
                      className={css.text}
                      dangerouslySetInnerHTML={{ __html: getColoredText(t.textId, index) }}
                    />
                  </div>
                  <div className={css.user}>
                    <img src={t.img} alt="testimonial" />
                    <div>
                      <div className={css.userName}>
                        <FormattedMessage id={t.nameId} />
                      </div>
                      <div className={css.userLocation}>
                        <FormattedMessage id={t.locationName} />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
        <div className={css.flipAnimationRight}>
          <svg
            width="96"
            height="86"
            viewBox="0 0 96 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M89.2727 31.9133C82.5239 24.2146 72.9932 19.5121 62.7773 18.8404C52.5613 18.1687 42.497 21.5827 34.7982 28.3315C27.0995 35.0803 22.397 44.611 21.7253 54.8269C21.0535 65.0429 24.4676 75.1072 31.2164 82.806L60.2445 57.3597L89.2727 31.9133Z"
              fill="#FEC220"
            />
          </svg>
        </div>
        <div className={css.flipAnimationLeft}>
          <svg
            width="96"
            height="86"
            viewBox="0 0 96 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M89.2727 31.9133C82.5239 24.2146 72.9932 19.5121 62.7773 18.8404C52.5613 18.1687 42.497 21.5827 34.7982 28.3315C27.0995 35.0803 22.397 44.611 21.7253 54.8269C21.0535 65.0429 24.4676 75.1072 31.2164 82.806L60.2445 57.3597L89.2727 31.9133Z"
              fill="#FEC220"
            />
          </svg>
        </div>
      </section>
    </div>
  );
};

OurLearnersCardComponent.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(OurLearnersCardComponent);
